module.exports = __webpack_public_path__ + "img/wx_psh_teacher_qrcode.f69e81e5.png";